import { render, staticRenderFns } from "./aiTextDrawer.vue?vue&type=template&id=5ac26050&scoped=true"
import script from "./aiTextDrawer.vue?vue&type=script&lang=js"
export * from "./aiTextDrawer.vue?vue&type=script&lang=js"
import style0 from "./aiTextDrawer.vue?vue&type=style&index=0&id=5ac26050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac26050",
  null
  
)

export default component.exports